/**
 * FaqModal — Full-screen FAQ overlay with categorized content.
 *
 * Categories: Alle, Anwendungen, Zulassungen/Systeme, Reinigung,
 *             Konfigurator, Handling/Montage, Verarbeitung
 */
export default class FaqModal {
  constructor() {
    this.categories = [
      'Alle', 'Anwendungen', 'Zulassungen/Systeme', 'Reinigung',
      'Konfigurator', 'Handling/Montage', 'Verarbeitung'
    ];

    this.faqData = [
      {
        q: 'Anleitung Konfigurator',
        a: '1) Eigenschaften mit den Filtern am unteren Bildrand wählen, wie z.B. Brandschutzklasse, U-Wert, usw.\n\n2) Ev. das Glas mit den Dropdown-Menus auf der rechten Seite anpassen, z.B. wenn das modellierte Glas zu dick ist.\n\n3) In den Warenkorb damit, Positionen erfassen und anfragen oder bestellen.\n\nTipp: Lege ein Konto an. Du erhältst dann auch eine Preisangabe und deine Daten sind für Anfragen und Bestellungen bereits hinterlegt.',
        cat: ['Konfigurator']
      },
      {
        q: 'Welche Punkte muss ich beachten, wenn ich Brandschutzglas anfrage oder bestelle?',
        a: 'Folgende Punkte sind wichtig, um von uns massgeschneidertes Brandschutzglas zu erhalten:\n\n– Feuerwiderstandsklasse: EI30, EI60, EI90, EI120 (EN 13501-2)\n– U-Wert (W/m²K) bei Isolierglas (EN 673)\n– Anwendung (Innen/Aussen)\n– Maximale Glasdicke, die dein System aufnehmen kann\n– Verwendetes System (Typ/VKF-Nummer)\n– ev. Widerstandsklasse (EN 1627)\n– ev. Schalldämmung Rw (EN 140-3)\n\nDu kannst auch ganz einfach unseren Konfigurator benutzen und dein Glas damit anfragen oder bestellen.',
        cat: ['Konfigurator', 'Anwendungen']
      },
      {
        q: 'Wie dick wird mein benötigtes Brandschutzglas?',
        a: 'Das hängt von diversen Faktoren ab. Am besten gibst du alle benötigten Eigenschaften in unserem Konfigurator ein, das dazugehörige Brandschutzglas wird dir dann inklusive Dicke direkt angezeigt.',
        cat: ['Konfigurator']
      },
      {
        q: 'Warum spielt es eine Rolle, ob ich das Glas innen oder aussen anwende?',
        a: 'Weil das Brandschutzglas nicht UV-stabil ist. Wenn du das Glas im Aussenbereich verwenden willst, muss es vor Sonneneinstrahlung geschützt werden. Dazu wird das Brandschutzglas auf der Aussenseite durch ein VSG (Verbundsicherheitsglas) erweitert, dessen PVB-Folien die UV-Strahlen absorbieren.',
        cat: ['Anwendungen']
      },
      {
        q: 'Welche Glasgrössen darf ich verwenden?',
        a: 'Die Grössen, die verwendet werden dürfen, stehen in den VKF-Anwendungen. Auch die Systemhäuser sollten diesbezüglich Auskunft geben können.',
        cat: ['Anwendungen', 'Zulassungen/Systeme']
      },
      {
        q: 'Ist das Glas von CDR für mein verwendetes System zugelassen?',
        a: 'Unsere Gläser sind in den allermeisten Systemen geprüft und zugelassen. Frag am besten bei deinem Systemhaus/Systemanbieter nach, was eingebaut werden darf.\n\nDie einzelnen Zulassungen können auch bei der VKF durchsucht und eingesehen werden: Registersuche',
        cat: ['Zulassungen/Systeme']
      },
      {
        q: 'Was ist eine VKF-Anerkennung?',
        a: 'Das ist ein von der VKF (Vereinigung Kantonaler Feuerversicherungen) ausgegebenes Dokument, aus dem du verschiedene Dinge herauslesen kannst. Du siehst da z.B. den Namen des Systems, den Inhaber der Zulassung, die geprüften Gläser/Hersteller in den zugelassenen Abmessungen, den erweiterten Anwendungsbereich, usw. Es braucht Übung und Geduld, sich diese Dokumente anzutun.',
        cat: ['Zulassungen/Systeme']
      },
      {
        q: 'Wo finde ich die VKF-Nummer?',
        a: 'Dein Systemanbieter wird sie dir geben können. Du kannst sie auch per Filter und Suchfelder im VKF-Register suchen gehen.',
        cat: ['Zulassungen/Systeme']
      },
      {
        q: 'Was bedeutet «VKF», resp. «VKF-Register»?',
        a: 'VKF steht für «Vereinigung kantonaler Feuerversicherungen». Im Register sind alle Brandschutzprodukte und Anwendungen zusammengefasst. Also auch die Brandschutzsysteme, in die unsere Gläser eingebaut werden können. Jede Anwendung hat eine eigene Nummer.',
        cat: ['Zulassungen/Systeme']
      },
      {
        q: 'Wie reinige ich Brandschutzglas?',
        a: 'Auf dieselbe Art und Weise, wie normales Fensterglas. Tipp: Gründliche Reinigung der ganzen Glasoberfläche erst im eingebauten Zustand und wenn die Silikonfugen gemacht sind. So kann kein Wasser in das Rahmensystem und somit an die empfindliche Glaskante gelangen.',
        cat: ['Reinigung']
      },
      {
        q: 'Ich habe Verschmutzungen auf dem Glas, die ich nicht reinigen kann. Könnt ihr mir helfen?',
        a: 'In seltenen Fällen kann es vorkommen, dass ein Glas mit Brandschutzgel-Rückständen auf der Oberfläche unser Haus verlässt. Dieser ist in eingetrocknetem Zustand kaum zu entfernen. Wende dich an uns, wir schicken dir die notwendigen Mittel oder kommen gleich selbst vorbei, und bringen das in Ordnung.',
        cat: ['Reinigung']
      },
      {
        q: 'Kann ich krummes, verbogenes Brandschutzglas wieder geraderichten?',
        a: 'Ja, das geht. Lege es vorsichtig auf Dämmplatten flach auf den Boden. Nach zwei, drei Stunden hat sich das Glas durch sein Eigengewicht wieder entspannt.',
        cat: ['Handling/Montage']
      },
      {
        q: 'Darf ich krummes, verbogenes Brandschutzglas montieren?',
        a: 'Nein, das sollte verhindert werden. Wenn Brandschutzglas in diesem Zustand verbaut wird, ist die Gefahr gross, dass es durch den zu schnellen Gegendruck kaputt geht.',
        cat: ['Handling/Montage']
      },
      {
        q: 'Darf ich Brandschutzglas ohne Support vorübergehend an die Wand stellen?',
        a: 'Besser nicht! Es wird sich rasch verbiegen. Und wenn du es in diesem Zustand einbaust, wird es kaputt gehen.',
        cat: ['Handling/Montage']
      },
      {
        q: 'Wie lagere ich Brandschutzglas?',
        a: 'Am besten lagerst du das Glas bis zur Montage auf dem von uns gelieferten Gestell. Auf jeden Fall musst du das Glas trocken und vor Sonneneinstrahlung geschützt lagern, also möglichst drinnen. Zudem muss das Glas vollflächig gestützt werden.',
        cat: ['Handling/Montage']
      },
      {
        q: 'Darf Brandschutzglas Sonnenlicht ausgesetzt werden?',
        a: 'Es kommt auf das Produkt an. Die beiden Glastypen FIRESWISS FOAM und PYROBEL sind grundsätzlich nicht UV-stabil, und deshalb vor direkter Sonneneinstrahlung zu schützen. PYROGUARD T ist UV-stabil und darf Sonnenlicht ausgesetzt werden.',
        cat: ['Verarbeitung', 'Handling/Montage']
      },
      {
        q: 'Darf Brandschutzglas nass werden?',
        a: 'Vor allem die Kanten nicht! Wir schützen diese mit einem Aluminium-Klebeband. Wenn Feuchtigkeit (Regen, Schnee, Wasser) zu lange über die Scheibe fliesst, oder das Glas im Wasser steht, wird sich das Klebeband ablösen und dann der Brandschutz-Gel herauslösen. Bitte deshalb das Brandschutzglas nicht im Aussenbereich lagern!',
        cat: ['Verarbeitung', 'Handling/Montage']
      },
      {
        q: 'Kann ich mir mein Glas auf die Baustelle liefern lassen?',
        a: 'Ja, selbstverständlich. Allerdings verlangen wir hierzu einen Mehrpreis.',
        cat: ['Anwendungen']
      },
      {
        q: 'Wie lange muss ich auf mein Glas warten?',
        a: 'Bei monolithischem Brandschutzglas beträgt die Lieferfrist in der Regel ca. zwei Wochen, für Brandschutz-Isolierglas ca. drei Wochen. Wenn es eilt, können wir dir dein Glas auch deutlich schneller zur Verfügung stellen. Melde dich einfach!',
        cat: ['Anwendungen']
      },
      {
        q: 'Wie kann ich schnell und einfach ein leeres Glasgestell zur Abholung melden?',
        a: 'An jedem Gestell findest du einen individuellen QR-Code. Wenn du diesen mit deinem Smartphone einliest, landest du auf dem Retour-Formular des Gestells. Dort kannst du uns über die Standortfreigabe den Ort für die Abholung melden.\n\nAlternativ ist auf der Website unten links ein Button, mit dem du über die Eingabe der Gestell-Nr. ebenfalls zum jeweiligen Retour-Formular gelangst.',
        cat: ['Handling/Montage']
      },
    ];

    this._buildModal();
    this._bindEvents();
  }

  _buildModal() {
    const overlay = document.createElement('div');
    overlay.className = 'faq-overlay hidden';
    overlay.id = 'faq-overlay';

    const modal = document.createElement('div');
    modal.className = 'faq-modal';

    // Header
    const header = document.createElement('div');
    header.className = 'faq-header';
    header.innerHTML = `
      <h2 class="faq-title">Häufige Fragen</h2>
      <button class="btn-icon faq-close" id="faq-close"><i class="fas fa-times"></i></button>
    `;
    modal.appendChild(header);

    // Category tabs
    const tabs = document.createElement('div');
    tabs.className = 'faq-tabs';
    this.categories.forEach((cat, i) => {
      const btn = document.createElement('button');
      btn.className = 'faq-tab' + (i === 0 ? ' active' : '');
      btn.dataset.cat = cat;
      btn.textContent = cat;
      tabs.appendChild(btn);
    });
    modal.appendChild(tabs);

    // Content
    const content = document.createElement('div');
    content.className = 'faq-content';
    content.id = 'faq-content';
    modal.appendChild(content);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    this.overlay = overlay;
    this.contentEl = content;
    this.tabsEl = tabs;

    this._renderCategory('Alle');
  }

  _renderCategory(category) {
    const items = category === 'Alle'
      ? this.faqData
      : this.faqData.filter(item => item.cat.includes(category));

    this.contentEl.innerHTML = '';

    items.forEach(item => {
      const faqItem = document.createElement('div');
      faqItem.className = 'faq-item';

      const question = document.createElement('button');
      question.className = 'faq-question';
      question.innerHTML = `
        <span>${item.q}</span>
        <i class="fas fa-chevron-down faq-chevron"></i>
      `;

      const answer = document.createElement('div');
      answer.className = 'faq-answer';
      // Convert newlines to paragraphs
      answer.innerHTML = item.a.split('\n\n').map(p =>
        `<p>${p.replace(/\n/g, '<br>')}</p>`
      ).join('');

      question.addEventListener('click', () => {
        const isOpen = faqItem.classList.contains('open');
        // Close all others
        this.contentEl.querySelectorAll('.faq-item.open').forEach(el => {
          el.classList.remove('open');
        });
        if (!isOpen) faqItem.classList.add('open');
      });

      faqItem.appendChild(question);
      faqItem.appendChild(answer);
      this.contentEl.appendChild(faqItem);
    });
  }

  _bindEvents() {
    // Toggle button
    const toggleBtn = document.getElementById('faq-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => this.open());
    }

    // Close button
    this.overlay.querySelector('#faq-close').addEventListener('click', () => this.close());

    // Click overlay to close
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.overlay.classList.contains('hidden')) {
        this.close();
      }
    });

    // Category tabs
    this.tabsEl.addEventListener('click', (e) => {
      const tab = e.target.closest('.faq-tab');
      if (!tab) return;
      this.tabsEl.querySelectorAll('.faq-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      this._renderCategory(tab.dataset.cat);
    });
  }

  open() {
    this.overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.overlay.classList.add('hidden');
    document.body.style.overflow = '';
  }
}
